export default {
  "leadConvertedAndMemberCreated": "Lead converted and member created",
  "members": "Members",
  "thisMemberDoesNotHaveAPhoneNumberOnFile": "This member does not have a phone number on file.",
  "pleaseSelectAClubInstanceFromTheTopRightSwitcherToManageMembers": "Please select a club instance from the top right switcher to manage members.",
  "importMembers": "Import Members",
  "addMember": "Add Member",
  "searchMembers": "Search members...",
  "noMembersFound": "No members found",
  "deleteMember": "Delete Member",
  "thisActionCannotBeUndone": "This action cannot be undone",
  "areYouSureYouWantToDelete": "Are you sure you want to delete",
  "thisWillPermanentlyRemoveTheirMembershipRecordAndAllAssociatedData": "? This will permanently remove their membership record and all associated data.",
  "deleting": "Deleting...",
  "describeTheMessageYouWantToSendAndILlWriteItForYouYouCanTypeOrUseYourVoice": "Describe the message you want to send, and I'll write it for you. You can type or use your voice.",
  "eGWriteAFriendlyFollowUpAboutTheMemberDinnerNextFridayAndAskIfTheyHaveAnyDietaryRestrictions": "e.g., 'Write a friendly follow-up about the member dinner next Friday and ask if they have any dietary restrictions.'",
  "stopListening": "Stop Listening",
  "useVoice": "Use Voice",
  "generateMessage": "Generate Message",
  "member": "Member",
  "sorryIWasUnableToGenerateAMessagePleaseTryAgain": "Sorry, I was unable to generate a message. Please try again.",
  "makeCall": "Make Call",
  "contactMember": "Contact Member",
  "failedToSendMessage": "Failed to send message",
  "lead": "Lead",
  "message": "Message",
  "willSendViaYourConnectedEmailProviderGmailOutlook": "Will send via your connected email provider (Gmail/Outlook)",
  "aiSuggestedReplies": "AI Suggested Replies",
  "generatingIdeas": "Generating ideas...",
  "messageSentSuccessfully": "Message sent successfully!",
  "call": "Call",
  "loadingActivityHistory": "Loading activity history...",
  "noActivityHistoryRecordedYet": "No activity history recorded yet.",
  "activity": "Activity",
  "reciprocalVisit": "Reciprocal Visit",
  "unknown": "Unknown",
  "noSmsInteractionsYet": "No SMS interactions yet.",
  "noEmailInteractionsYet": "No email interactions yet.",
  "noCallInteractionsYet": "No call interactions yet.",
  "noInteractionsLoggedForThisMemberYet": "No interactions logged for this member yet.",
  "openInSmsModule": "Open in SMS module",
  "loadingMoreInteractions": "Loading more interactions...",
  "overdue": "Overdue",
  "annualDues": "Annual Dues:",
  "interactions": "Interactions:",
  "activities": "Activities:",
  "memberSince": "Member Since",
  "viewProfile": "View Profile",
  "callMember": "Call Member",
  "editMember": "Edit Member",
  "spouse": "Spouse",
  "partner": "Partner",
  "parent": "Parent",
  "sibling": "Sibling",
  "guardian": "Guardian",
  "other": "Other",
  "unableToLoadProfileGroups": "Unable to load profile groups.",
  "vegetarian": "Vegetarian",
  "vegan": "Vegan",
  "pescatarian": "Pescatarian",
  "glutenFree": "Gluten-free",
  "dairyFree": "Dairy-free",
  "halal": "Halal",
  "kosher": "Kosher",
  "nutAllergy": "Nut allergy",
  "otherAllergy": "Other allergy",
  "otherRequirement": "Other requirement",
  "preferredTitle": "Preferred title",
  "firstName": "First name",
  "middleNames": "Middle names",
  "lastName": "Last name",
  "preferredName": "Preferred name",
  "gender": "Gender",
  "dateOfBirth": "Date of birth",
  "maritalStatus": "Marital status",
  "anniversary": "Anniversary",
  "signInEmail": "Sign-in email",
  "readOnlyAccountEmail": "Read-only account email",
  "contactEmail": "Contact email",
  "secondaryEmail": "Secondary email",
  "mobile": "Mobile",
  "homeTelephone": "Home telephone",
  "workTelephone": "Work telephone",
  "personal": "Personal",
  "profile": "Profile",
  "contact": "Contact",
  "addresses": "Addresses",
  "emergency": "Emergency",
  "family": "Family",
  "dietary": "Dietary",
  "vehicles": "Vehicles",
  "unableToLoadActivityDetails": "Unable to load activity details",
  "pleaseChooseAnInteractionType": "Please choose an interaction type.",
  "unableToSaveInteraction": "Unable to save interaction",
  "failedToAddInteraction": "Failed to add interaction",
  "backToMembers": "Back to Members",
  "memberNotFound": "Member not found.",
  "golfBooking": "Golf Booking",
  "racquetBooking": "Racquet Booking",
  "fitnessClass": "Fitness Class",
  "spaBooking": "Spa Booking",
  "reciprocalClubVisit": "Reciprocal Club Visit",
  "roomReservation": "Room Reservation",
  "eventAttendance": "Event Attendance",
  "activityDetails": "Activity Details",
  "unknownMember": "Unknown member",
  "viewProfilePicture": "View profile picture",
  "phone": "Phone",
  "membershipNumber": "Membership Number",
  "annualDues2": "Annual Dues",
  "weddingDate": "Wedding date",
  "anniversary2": "Anniversary:",
  "address": "Address",
  "emergencyContact": "Emergency Contact",
  "loadingFamilyMembers": "Loading family members...",
  "noLinkedFamilyMembers": "No linked family members.",
  "boats": "Boats",
  "boat": "Boat",
  "horses": "Horses",
  "horse": "Horse",
  "sportLevels": "Sport Levels",
  "golfHcp": "Golf Hcp",
  "tennisLevel": "Tennis Level",
  "padelLevel": "Padel Level",
  "visualMemberProfileCards": "Visual member profile cards",
  "profileGroups": "Profile groups",
  "loading": "Loading…",
  "primaryPostal": "Primary postal",
  "noAddressesRecorded": "No addresses recorded.",
  "emergencyContact2": "Emergency contact",
  "accepted": "• Accepted",
  "memberConsentRequests": "Member consent requests",
  "incomingToMember": "Incoming to member",
  "outgoingFromMember": "Outgoing from member",
  "removal": "Removal",
  "add": "Add",
  "noDietaryRequirementsRecorded": "No dietary requirements recorded.",
  "primaryVehicle": "Primary vehicle",
  "noVehiclesRecorded": "No vehicles recorded.",
  "memberDetails": "Member details",
  "crmLeadHistory": "CRM lead history",
  "achievementsHistory": "Achievements / History",
  "interactions2": "Interactions (",
  "activityHistory": "Activity History (",
  "financial": "Financial",
  "memberInteractionHistory": "Member Interaction History",
  "completeRecordOfAllCommunicationsAndInteractions": "Complete record of all communications and interactions",
  "filter": "Filter",
  "allInteractions": "All interactions",
  "all": "All",
  "activityHistory2": "Activity History",
  "loggedActivitiesForThisMember": "Logged activities for this member",
  "bookingMemberName": "Booking member name",
  "bookingMemberNumber": "Booking member number",
  "service": "Service",
  "spaService": "Spa service",
  "therapist": "Therapist",
  "notAssigned": "Not assigned",
  "room": "Room",
  "destinationClub": "Destination club",
  "reciprocalType": "Reciprocal type",
  "confirmationNumber": "Confirmation number",
  "guests": "Guests",
  "checkIn": "Check-in",
  "checkOut": "Check-out",
  "event": "Event",
  "attendees": "Attendees",
  "weCouldnTMatchThisActivityToAKnownDetailModalYet": "We couldn't match this activity to a known detail modal yet.",
  "title": "Title:",
  "occurredAt": "Occurred at:",
  "typeKey": "Type key:",
  "players": "Players",
  "guest": "Guest",
  "unknownPlayer": "Unknown player",
  "hcp": "Hcp:",
  "noPlayersRecorded": "No players recorded.",
  "addOns": "Add-ons",
  "addOn": "Add-on",
  "qty": "Qty:",
  "noAddOnsRecorded": "No add-ons recorded.",
  "loadingTypes": "Loading types…",
  "noMembershipTypesFound": "No membership types found",
  "active": "Active",
  "sortBy": "Sort by...",
  "newestFirst": "Newest First",
  "nameAZ": "Name (A-Z)",
  "nameZA": "Name (Z-A)",
  "membershipAsc": "Membership # (Asc)",
  "membershipDesc": "Membership # (Desc)",
  "mostInteractions": "Most Interactions",
  "mostActivities": "Most Activities",
  "inCreditBy": "In credit by",
  "balanceDue": "Balance due",
  "noOverdueInvoices": "No overdue invoices",
  "unableToLoadFinancialData": "Unable to load financial data",
  "membershipDuesStatus": "Membership Dues Status",
  "readOnlyDuesStatusAndRecentBillingActivity": "Read-only dues status and recent billing activity.",
  "youDonTHavePermissionToViewMemberFinancials": "You don’t have permission to view member financials.",
  "currentDuesStatus": "Current dues status",
  "activeTemplate": "Active template",
  "notConfigured": "Not configured",
  "nextInvoiceDate": "Next invoice date",
  "outstandingDuesBalance": "Outstanding dues balance",
  "latestDuesInvoice": "Latest dues invoice",
  "noDuesInvoiceYet": "No dues invoice yet",
  "latestDuesInvoiceDue": "Latest dues invoice due",
  "overdueDuesInvoices": "Overdue dues invoices",
  "recentDuesPayments": "Recent dues payments",
  "financialSummary": "Financial Summary",
  "memberNetPaidBalanceAndOverdueInsights": "Member net paid, balance, and overdue insights.",
  "netPaidYtd": "Net paid YTD",
  "netPaidMtd": "Net paid MTD",
  "netPaidWtd": "Net paid WTD",
  "netPaidToday": "Net paid today",
  "balance": "Balance",
  "latestOverdueInvoice": "Latest overdue invoice",
  "accountActivity": "Account Activity",
  "canonicalMemberAccountChargesAndLedgerActivity": "Canonical member account charges and ledger activity.",
  "noMemberAccountActivityFound": "No member account activity found.",
  "date": "Date",
  "type": "Type",
  "notRecorded": "Not recorded",
  "payments": "Payments",
  "mostRecentPaymentsAndAllocations": "Most recent payments and allocations.",
  "noPaymentsFoundForThisMember": "No payments found for this member.",
  "paidAt": "Paid at",
  "allocations": "Allocations",
  "allocation": "allocation",
  "noAllocations": "No allocations",
  "loadMore": "Load more",
  "unableToResolveClubForFamilyLinks": "Unable to resolve club for family links",
  "unableToResolveClubForMembershipTypes": "Unable to resolve club for membership types",
  "failedToLoadMembershipTypes": "Failed to load membership types",
  "unableToSearchMembers": "Unable to search members",
  "unableToDetermineClubForUpload": "Unable to determine club for upload",
  "uploadFailed": "Upload failed",
  "errorClubContextIsNotAvailableCannotSaveMember": "Error: Club context is not available. Cannot save member.",
  "pleaseProvideFirstNameLastNameEmailAndMembershipNumber": "Please provide first name, last name, email, and membership number.",
  "phoneNumberIsRequired": "Phone number is required",
  "pleaseEnterAValidPhoneNumberE164": "Please enter a valid phone number (E.164)",
  "unableToUpdateMember": "Unable to update member",
  "unableToCreateMember": "Unable to create member",
  "failedToSaveMemberPleaseTryAgain": "Failed to save member. Please try again.",
  "areYouSureYouWantToDeleteThisMemberThisCannotBeUndone": "Are you sure you want to delete this member? This cannot be undone.",
  "errorClubContextIsNotAvailableCannotDeleteMember": "Error: Club context is not available. Cannot delete member.",
  "unableToDeleteMember": "Unable to delete member",
  "failedToDeleteMemberPleaseTryAgain": "Failed to delete member. Please try again.",
  "unableToAddFamilyLink": "Unable to add family link",
  "unableToRemoveFamilyLink": "Unable to remove family link",
  "addNewMember": "Add New Member",
  "enterTheDetailsForTheClubMemberBelow": "Enter the details for the club member below.",
  "memberAvatar": "Member avatar",
  "uploading": "Uploading...",
  "uploadPhoto": "Upload photo",
  "removePhoto": "Remove photo",
  "currentMembershipTerm": "Current membership term",
  "unspecified": "Unspecified",
  "started": "Started",
  "renewal": "; renewal",
  "renewalDateOverrideOptional": "Renewal date override (optional)",
  "firstName2": "First Name",
  "lastName2": "Last Name",
  "localNumber": "Local number",
  "enterMembershipNumber": "Enter membership number",
  "joinDate": "Join Date",
  "dateOfBirth2": "Date of Birth",
  "linkRelatedMembersWithinThisClub": "Link related members within this club.",
  "saveTheMemberFirstToAddFamilyLinks": "Save the member first to add family links.",
  "searchMembers2": "Search members",
  "typeANameOrMembershipNumber": "Type a name or membership number",
  "noMembershipNumber": "No membership number",
  "noMembersMatchThatSearch": "No members match that search.",
  "relation": "Relation",
  "linkedMembers": "Linked members",
  "remove": "Remove",
  "noFamilyMembersLinkedYet": "No family members linked yet.",
  "deleteMember2": "Delete member",
  "renewalDateOverride": "Renewal date override",
  "onlyCsvFilesAreSupportedForImportPleaseUploadACsvFile": "Only CSV files are supported for import. Please upload a .csv file.",
  "currentClubContextIsMissingCannotImportMembersWithoutATenantId": "Current club context is missing. Cannot import members without a tenant ID.",
  "chooseImportMethod": "Choose Import Method",
  "uploadExistingFile": "Upload Existing File",
  "uploadACsvFileWithYourMemberData": "Upload a CSV file with your member data",
  "supportedFormatsCsv": "Supported formats: CSV",
  "useOurTemplate": "Use Our Template",
  "downloadAPreFormattedTemplateWithSampleData": "Download a pre-formatted template with sample data",
  "downloadTemplate": "Download Template",
  "fillOutTheTemplateAndUploadItAbove": "Fill out the template and upload it above",
  "processingFile": "Processing file...",
  "mapYourFields": "Map Your Fields",
  "matchYourDataColumnsToPrivanaFieldsRequiredFieldsAreMarkedWith": "Match your data columns to Privana fields. Required fields are marked with *",
  "selectColumn": "Select column...",
  "noMapping": "-- No mapping --",
  "back": "Back",
  "previewImport": "Preview Import",
  "reviewTheFirst5RowsOfYourMappedDataBeforeImporting": "Review the first 5 rows of your mapped data before importing",
  "members2": "members",
  "willBeImportedPleaseVerifyThePreviewDataLooksCorrectBeforeProceeding": "will be imported. Please verify the preview data looks correct before proceeding.",
  "backToMapping": "Back to Mapping",
  "startImport": "Start Import",
  "importComplete": "Import Complete",
  "successfullyImported": "Successfully Imported",
  "failedToImport": "Failed to Import",
  "errors": "Errors:",
  "row": "Row",
  "seeTheSalesInteractionsThatHappenedBeforeThisMemberJoined": "See the sales interactions that happened before this member joined.",
  "loadingLeadHistory": "Loading lead history…",
  "unableToLoadLeadHistoryForThisMember": "Unable to load lead history for this member.",
  "originallyCapturedAsCrmLead": "Originally captured as CRM lead.",
  "noCrmInteractionsWereLoggedForThisLead": "No CRM interactions were logged for this lead.",
  "interaction": "Interaction",
  "name": "Name",
  "membership": "Membership #",
  "associateCallRecord": "Associate Call Record",
  "multipleMembersMatchThePhoneNumberFromTheCallWith": "Multiple members match the phone number from the call with",
  "unknownCaller": "Unknown Caller",
  "pleaseSelectWhichMemberToLogThisActivityFor": ". Please select which member to log this activity for.",
  "linkedCount": "{count} linked",
  "requiredMappings": "Please map the following required fields: {fields}",
  "dueInDays": "Due in {count} days",
  "dueOn": "Due {date}",
  "years": "{count} years",
  "overdueDays": "Overdue by {count} days",
  "holes": "{count} holes",
  "playersCount": "{count} players",
  "onePlayer": "1 player",
  "parseFailed": "Unable to parse this CSV. Check that each row has the same columns as the header.",
  "readFailed": "Unable to read this file. Please try again.",
  "preparationFailed": "Unable to prepare this row. Check its data and retry.",
  "importFailed": "Unable to complete the import. Please try again.",
  "tenure": "({years}yr, {months}m)",
  "importFields": {
    "first_name": "First Name",
    "last_name": "Last Name",
    "email": "Email",
    "phone": "Phone",
    "membership_type": "Membership Type",
    "membership_number": "Membership Number",
    "membership_term_start": "Membership term start",
    "renewal_date_override": "Renewal date override",
    "joined_at": "Joining date",
    "join_date": "Join Date",
    "status": "Status",
    "emergency_contact": "Emergency Contact",
    "address": "Address",
    "notes": "Notes",
    "membership_type_id": "Membership Type ID",
    "membership_type_name": "Membership Type Name",
    "date_of_birth": "Date of Birth"
  },
  "fieldTypes": {
    "text": "Text",
    "email": "Email",
    "select": "Option",
    "date": "Date"
  },
  "child": "Child",
  "followUpPlaceholder": "Follow-up from {name}'s Profile",
  "loadMembersFailed": "Unable to load members. Please try again.",
  "loadingMembers": "Loading members…",
  "smsRouting": {
    "inbound_member_priority_alpha": {
      "label": "Auto-routed: Member priority",
      "tooltip": "This phone number matches multiple people in Privana. This inbound SMS was auto-routed to this member using the inbound member-first alphabetical rule."
    },
    "explicit_member": {
      "label": "Routed: Explicit member",
      "tooltip": "This SMS was sent from a member-context flow, so it was explicitly routed to this member."
    },
    "explicit_lead": {
      "label": "Routed: Explicit lead",
      "tooltip": "This SMS was sent from a lead-context flow, so it was explicitly routed to this lead."
    },
    "single_match_member": {
      "label": "Routed: Single member match"
    },
    "single_match_lead": {
      "label": "Routed: Single lead match"
    },
    "manual_outbound_selection": {
      "label": "Routed: Manual selection"
    }
  },
  "communicationUnableToLoadSmsSettings": "Unable to load SMS settings",
  "communicationPleaseEnterInstructionsForWhatYouWantToSay": "Please enter instructions for what you want to say.",
  "communicationUnableToGenerateDraftsRightNowPleaseTryAgain": "Unable to generate drafts right now. Please try again.",
  "communicationRoutingSaved": "Routing saved",
  "communicationSmsInteractionIsNowLinkedToTheSelectedPerson": "SMS interaction is now linked to the selected person.",
  "communicationUnableToSaveRouting": "Unable to save routing",
  "communicationMissingRecipientPhone": "Missing recipient phone",
  "communicationSelectAFromNumber": "Select a from number",
  "communicationPleaseChooseWhichClubNumberToSendFrom": "Please choose which club number to send from.",
  "communicationSmsBlocked": "SMS blocked",
  "communicationThisMemberHasOptedOutOfSms": "This member has opted out of SMS.",
  "communicationThisMemberHasNotConsentedToSms": "This member has not consented to SMS.",
  "communicationUnableToSendSmsAtThisTime": "Unable to send SMS at this time.",
  "communicationProviderDidNotAcceptTheMessagePleaseTryAgain": "Provider did not accept the message. Please try again.",
  "communicationSmsSent": "SMS sent",
  "communicationMessageSentChooseWhoThisSmsShouldBeLoggedAgainst": "Message sent. Choose who this SMS should be logged against.",
  "communicationYourMessageIsOnItsWay": "Your message is on its way.",
  "communication160Characters": "/160 characters",
  "communicationFromNumber": "From number",
  "communicationLoadingNumbers": "Loading numbers...",
  "communicationSelectANumber": "Select a number",
  "communicationNoSmsEnabledClubNumbersAreAvailableEnableSmsForADidInAdminVoipNumbers": "No SMS-enabled club numbers are available. Enable SMS for a DID in Admin → VoIP Numbers.",
  "communicationDraftingAReply": "Drafting a reply...",
  "communicationSuggestedReply": "Suggested reply",
  "communicationUseReply": "Use Reply",
  "communicationRegenerate": "Regenerate",
  "communicationCouldnTDraftReply": "Couldn’t draft reply.",
  "communicationWillSendViaTwilioSmsService": "Will send via Twilio SMS service",
  "communicationThisNumberBelongsToMultiplePeopleInPrivanaWhoWasThisSmsIntendedFor": "This number belongs to multiple people in Privana. Who was this SMS intended for?",
  "communicationNoPhone": "No phone",
  "communicationNoRoutingCandidatesAvailable": "No routing candidates available.",
  "communicationDescribeWhatYouWantToSendThenReviewAndEditTwoDraftSmsOptions": "Describe what you want to send, then review and edit two draft SMS options.",
  "communicationInstruction": "Instruction",
  "communicationExampleRemindThemTheirTourIsTomorrowAt10AmAndAskThemToReplyIfTheyNeedToReschedule": "Example: Remind them their tour is tomorrow at 10 AM and ask them to reply if they need to reschedule.",
  "communicationGeneratingOptions": "Generating options...",
  "communicationGenerateOptions": "Generate options",
  "communicationOption1": "Option 1",
  "communicationOption2": "Option 2",
  "communicationUseThis": "Use this",
  "communicationSmsThread": "SMS Thread",
  "communicationViewAndReplyWithoutLeavingThisPage": "View and reply without leaving this page.",
  "communicationUnableToLoadMessages": "Unable to load messages.",
  "communicationLoadingMessages": "Loading messages...",
  "communicationNoMessagesInThisConversationYet": "No messages in this conversation yet.",
  "communicationConversation": "Conversation",
  "communicationScrollToViewAllMessages": "Scroll to view all messages",
  "communicationNewEmail": "New email",
  "communicationAddAtLeastOneRecipientToForwardReply": "Add at least one recipient to forward/reply.",
  "communicationMessageCannotBeEmpty": "Message cannot be empty.",
  "communicationUnableToSendEmail": "Unable to send email",
  "communicationPleaseTryAgainInAMoment": "Please try again in a moment.",
  "communicationEmailSent": "Email sent",
  "communicationForwardSent": "Forward sent",
  "communicationReplySent": "Reply sent",
  "communicationDeliverySucceededMessageMetadataIsSyncing": "Delivery succeeded. Message metadata is syncing.",
  "communicationMessageSent": "Message sent",
  "communicationSentSuccessfullyConversationRefreshIsStillSyncing": "Sent successfully. Conversation refresh is still syncing.",
  "communicationEmailThread": "Email thread",
  "communicationLoadingConversation": "Loading conversation…",
  "communicationComposeANewEmailToStartAConversation": "Compose a new email to start a conversation.",
  "communicationNoConversationMessagesAvailable": "No conversation messages available.",
  "communicationYou": "You",
  "communicationUnknownSender": "Unknown sender",
  "communicationUnknownEmail": "Unknown email",
  "communicationHideCcBcc": "Hide CC/BCC",
  "communicationCcBcc": "CC/BCC",
  "communicationCc": "CC",
  "communicationBcc": "BCC",
  "communicationComposeEmail": "Compose Email",
  "communicationComposeReply": "Compose Reply",
  "communicationTone": "Tone",
  "communicationBrief": "Brief",
  "communicationSyncingSent": "{status}. Syncing sent item…",
  "smsDelivery": {
    "queued": "Queued",
    "sending": "Sending",
    "sent": "Sent",
    "delivered": "Delivered",
    "failed": "Failed",
    "undelivered": "Undelivered",
    "scheduled": "Scheduled"
  },
  "player": "Player",
  "profileChoices": {
    "female": "Female",
    "male": "Male",
    "nonBinary": "Non-binary",
    "undisclosed": "Prefer not to say",
    "other": "Other",
    "single": "Single",
    "married": "Married",
    "civilPartnership": "Civil partnership",
    "partnered": "Partnered",
    "separated": "Separated",
    "divorced": "Divorced",
    "widowed": "Widowed"
  }
};
